<div class="container card py-5" [id]="data?.details?.id" [dir]="language === 'ar' ? 'rtl' : 'ltr'">
   <div >
      <div class="col-12">
         <h3 class="section-heading">
            {{ extractTitle(data.details.title, 1) }}
            <span>{{ extractTitle(data.details.title, 2) }}</span>
         </h3>
      </div>
      <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 justify-content-center">
         <div class="col" *ngFor="let item of data.details.services">
            <a
            *ngIf="data.details.isDetails"
            [href]="getDetailsUrl(item)"
            class="service-card"
            >
            <div class="service-img-wrapper">
               <img
               [src]="item.imageIconPath"
               [alt]="item.imageAlt"
               class="service-img"
               [class.side]="
               data.details.imageCover !== undefined
               ? !data.details.imageCover
               : false
               "
               loading="lazy"
               />
            </div>
            <div class="service-body">
               <div class="service-title">{{ item.titleTr }}</div>
               <div class="service-summary" [innerHTML]="item.summary"></div>
            </div>
            </a>
            <div *ngIf="!data.details.isDetails" class="service-card">
               <div class="service-img-wrapper">
                  <img
                  *ngIf="item.imageIconPath"
                  [src]="item.imageIconPath"
                  [alt]="item.imageAlt"
                  class="service-img"
                  loading="lazy"
                  />
               </div>
               <div class="service-body" [ngClass]="{ 'with-border': item.withBorder }">
                  <div class="service-title">{{ item.titleTr }}</div>
                  <div class="service-summary" [innerHTML]="item.summary"></div>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>